if (typeof ProductItemHover !== 'function') {
    window.ProductItemHover = class extends HTMLElement {
      constructor() {
        super();
        this.wrapper = this.closest('.product-item__image--wrapper');
        this.handled = false;
        this.template = this.querySelector('template');
        
        if (this.wrapper && this.template) {
          
          const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          
          // Only load content on intersection for desktop
          if (!isMobile) {
            
            const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting && !this.handled) {
                  const content = this.template.content.cloneNode(true);
                  this.appendChild(content);
                  this.handled = true;
                  this.wrapper.classList.add('product-item__image--hover');
                  observer.unobserve(this);
                }
              });
            }, { rootMargin: '50px' });
            
            observer.observe(this);
          }
        }
      }
    }
  }
  
  if (typeof customElements.get('product-item-hover') === 'undefined') {
    customElements.define('product-item-hover', window.ProductItemHover);
  }